import { AxiosResponse } from "axios";

import API from "../api";

import { IUploadCentreCreateStaffList, Staff } from "../models/staff";

const ROUTE_NAME = "staffs";

const StaffService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Staff>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Staff[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(staff: Staff): Promise<AxiosResponse<Staff>> {
    return await API.post(`/${ROUTE_NAME}`, staff);
  },
  async update(id: number, staff: Staff): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, staff);
  },
  async postCSV(data: IUploadCentreCreateStaffList[]): Promise<AxiosResponse<Staff[]>>{
    return await API.post(`/${ROUTE_NAME}/list`, data);
  },
};

export default StaffService;
